import React, { lazy } from 'react';
import { useContext } from 'react';
import { useI18next } from 'gatsby-plugin-react-i18next';
import { GlobalStateContext } from '@context/context';
import TopNavigation from '@components/TopNavigation';
import { AcademyBanner } from '@components/Banners';
import HydrationSuspense from '@components/HydrationSuspense';
import './style.scss';

const Footer = lazy(() => import('@components/Footer'));

const Layout = ({
  children,
  classes = '',
  navType,
  progressBar,
  LogoComponent,
  topNavClasses = '',
}) => {
  const { path } = useI18next();

  const { showInfoBox } = useContext(GlobalStateContext);

  const isBlogPage = path.includes('/blog/');
  const isPlaybookPage = path.includes('/resources/playbooks/');
  const isSuccessStoriesPage = path.includes('/customers/');
  const isNewsletterPage = path.includes('/resources/newsletters/');
  const isAcademyPage = path.includes('/resources/academy/');
  const isProductUpdatePage = path.endsWith('/platform/product-updates/');
  const isHomePage = path === '/';

  const hideSubscribeForm =
    isBlogPage ||
    isPlaybookPage ||
    isSuccessStoriesPage ||
    isProductUpdatePage ||
    isNewsletterPage ||
    isAcademyPage ||
    isHomePage;

  return (
    <>
      {showInfoBox && isAcademyPage && <AcademyBanner />}
      {/*{!isDealfrontAIPage && !isAcademyPage && showInfoBox && (
        <DealfrontAIBanner />
      )}*/}
      <TopNavigation
        navType={navType}
        progressBar={progressBar}
        LogoComponent={LogoComponent}
        classes={topNavClasses}
      />
      <main className={`${classes} ${isBlogPage ? 'blog-page' : ""}`}>{children}</main>
      <HydrationSuspense>
        <Footer hideSubscribeForm={hideSubscribeForm} />
      </HydrationSuspense>
    </>
  );
};

export default Layout;
